import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anonymous

  useEffect(() => {
    const token = localStorage.getItem("myclinic_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("myclinic_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) {
      return { mfaRequired: true, mfaToken: data.mfa_token };
    }
    localStorage.setItem("myclinic_token", data.access_token);
    setUser(data.user);
    return { user: data.user };
  };

  const completeMfa = async (mfaToken, { code, backupCode }) => {
    const { data } = await api.post("/auth/login/2fa", {
      mfa_token: mfaToken,
      code: code || undefined,
      backup_code: backupCode || undefined,
    });
    localStorage.setItem("myclinic_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("myclinic_token");
    localStorage.removeItem("myclinic_active_clinic");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, completeMfa, refreshUser, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
